import "./index.scss";

const ButtonContent = ({ children }) => {
  return <div className="btn-with-container">{children}</div>;
};

export default ButtonContent;
